export default __webpack_public_path__ + "static/media/SH.8c0d0879.txt";